export const sendComscoreBeacon = () => {
  if (typeof window !== 'undefined' && window.COMSCORE) {
    window.COMSCORE.beacon({
      c1: '2',
      c2: '28893285',
      cs_ucfr: '',
      options: {
        enableFirstPartyCookie: true,
        bypassUserConsentRequirementFor1PCookie: true,
      },
    });
  }
};
